import { Routes } from '@angular/router';
import { titleFormatter } from '@core/utils/general.utils';

export const memberRoutes: Routes = [
  {
    path: 'members',
    title: titleFormatter('Members'),
    data: { title: 'Members' },
    loadComponent: () => import('./pages/Home/Home.component').then((m) => m.HomeComponent),
  },
];
